import React from 'react';
import { useIntl } from 'react-intl';
import { AlertCircle } from 'lucide-react';

const ErrorPage = () => {
  const intl = useIntl();

  return (
    <div className="mx-[1vw] bg-[#EAEAEA] border-2 border-[#DEDEDE] min-h-[calc(100%-4px)] p-10 text-[#333]">
      <div className="flex justify-center mb-6">
        <AlertCircle size={50} className="text-red-500" />
      </div>
      <h2 className="text-center text-xl font-bold mb-4">{intl.formatMessage({ id: 'ORDER_SHOW_ERROR_MESSAGE' })}</h2>
      <div className="mb-6">
        <p>{intl.formatMessage({ id: 'ORDER_REQUESTED_SHOW_ERROR_MESSAGE' })}</p>
      </div>
      <h3 className="font-bold text-lg mb-2">{intl.formatMessage({ id: 'HOW_TO_SOLVE' })}</h3>
      <p className="mb-4">{intl.formatMessage({ id: 'VERIFY_THE_FOLLOWING_RULES_MESSAGE' })}</p>
      <ul className="list-disc ml-6 mb-6 space-y-1">
        <li>
          {intl.formatMessage({ id: 'PROPERTY_TYPE_VALUE_MESSAGE' })}
          <ul className="list-circle ml-6 mt-1 space-y-1">
            <li>{intl.formatMessage({ id: 'DUPLEX' })}</li>
            <li>{intl.formatMessage({ id: 'APARTMENT' })}</li>
            <li>{intl.formatMessage({ id: 'HOUSE' })}</li>
            <li>{intl.formatMessage({ id: 'KITETTE' })}</li>
            <li>{intl.formatMessage({ id: 'LOFT' })}</li>
            <li>{intl.formatMessage({ id: 'STORE' })}</li>
            <li>{intl.formatMessage({ id: 'ROOM' })}</li>
            <li>{intl.formatMessage({ id: 'SHED' })}</li>
            <li>{intl.formatMessage({ id: 'GARAGE' })}</li>
            <li>{intl.formatMessage({ id: 'BUILDING' })}</li>
            <li>{intl.formatMessage({ id: 'GROUND' })}</li>
            <li>{intl.formatMessage({ id: 'FARMHOUSE' })}</li>
          </ul>
        </li>
        <li>{intl.formatMessage({ id: 'ADDRESS_FILLED_MESSAGE' })}</li>
        <li>{intl.formatMessage({ id: 'PROPERTY_AREA_REGISTERED_MESSAGE' })}</li>
      </ul>
      <p className="text-sm opacity-80">{intl.formatMessage({ id: 'INSPECTION_DOWNLOAD_MESSAGE' })}</p>
    </div>
  );
};

export default ErrorPage;
